export default __webpack_public_path__ + "static/media/cycloneofsteel3.51e87fc4.png";